












import { Component, Vue, Prop } from 'vue-property-decorator';
import MainTitle, {
  MainTitleItem,
  MainTitleSize,
} from '@/components/common/MainTitle.vue';
import MainParagraph from '@/components/common/MainParagraph.vue';

@Component({
  components: { MainTitle, MainParagraph },
})
export default class TitleContainer extends Vue {
  @Prop({ required: true })
  items!: MainTitleItem[];

  @Prop({ default: MainTitleSize.Large })
  titleSize!: MainTitleSize;

  @Prop({ required: false })
  text: string;

  @Prop({ default: '50' })
  marginBottom!: string;

  @Prop({ default: 'text-center' })
  textAlign!: string;

  @Prop({ default: true })
  withFullStop!: boolean;
}
